// Module
var code = "<!-- ko if: editorLoading -->\r\n<spinner class=\"fit\"></spinner>\r\n<!-- /ko -->\r\n\r\n<div tabindex=\"0\" class=\"fit\" data-bind=\"codeEditor: { editorContent, onChange, editorLoading }\"></div>";
// Exports
export default code;